<template lang="pug">
div
  v-card(flat)
    v-card-title Signage &amp; Advertising
    keep-alive
      validation-observer(
        ref="o12",
        v-slot="{ invalid }",
        :persist="true",
        vid="o12"
      )
        v-container
          v-row
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Do you plan signage/advertisement at the site?
              validation-provider(rules="required", v-slot="{ errors }" immediate)
                v-radio-group(
                  v-model="SEA_Signage",
                  row,
                  dense,
                  :disabled="disabled"
                )
                  v-radio(
                    v-for="option in yesNoString",
                    :key="option",
                    :label="option",
                    :value="option"
                  )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row(v-if="SEA_Signage === 'Yes'")
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Permits
              ul
                li Contact the Zoning Office at 703-228-3883 to obtain a permit to have event signs posted prior to the event.
                li Limited signs may be posted the day of the event. All signs must be removed at the conclusion of the event.
                li Limited banners in designated areas can be placed with approval from the Zoning Office.
          v-row(v-if="SEA_Signage === 'Yes'")
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Location and Description
              p.pb-0.pl-8.text--secondary List locations and describe where you plan to place signage and advertising.
              v-textarea.pb-3.pl-3(
                outlined,
                hide-details,
                dense,
                v-model="SEA_SignageLocDesc",
                :disabled="disabled"
              )
</template>


<script>
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import store from "../store";

export default {
  components: {
    //
  },
  store,
  computed: {
    ...mapState({
      data: (state) => state.data,
      yesNoString: (state) => state.yesNoString,
    }),
    ...mapFields([
      "data.SEA_Signage",
      "data.SEA_SignageLocDesc",
      "data.disabled",
    ]),
  },
  data: () => ({
    //
  }),
  methods: {
    //
  },
};
</script>